
import styled from "styled-components"
import { LuEye } from "react-icons/lu";
import { LuEyeOff } from "react-icons/lu";

const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;
    color: ${({ theme }) => theme.mainTextColor};
    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
        position: relative;
        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }
    .eye{
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 20px;
        color: ${({theme}) => theme.mainTextColor};

        .icon{
            font-size: 1rem;
        }
    }
`

const InputPassword = ({data, setData, name, labelText, inputWidth, isShow, setIsShow, auto}) => {

  return (
    <Container value={data} radius={"5px"} inputWidth={inputWidth}>
        <input onChange={setData} type={isShow ? "text" : "password"} value={data} name={name} autoComplete={auto}/>
        <div className="eye">
            {isShow ?
                <LuEye onClick={setIsShow} className="icon"/>
                :
                <LuEyeOff onClick={setIsShow} className="icon"/>
            }
        </div>

        <label>{labelText}</label>
    </Container>
  )
}

export default InputPassword